import { Injectable } from '@angular/core';
import { AlarisLanguageService } from '@campaign-portal/components-library';
import { DsNotificationService } from '@alarislabs/angular-components/notification';

@Injectable({ providedIn: 'root' })
export class EntityNotificationService {
	constructor(
		private readonly languageService: AlarisLanguageService,
		private readonly notificationService: DsNotificationService,
	) {}

	showSuccess(entityKey: string, type: 'created' | 'updated' | 'deleted'): void {
		const actionKeyMap: Record<string, string> = {
			created: 'actions.created',
			updated: 'actions.updated',
			deleted: 'actions.deleted',
		};
		const actionKey = actionKeyMap[type];
		const content = this.languageService.translate(entityKey) + this.languageService.translate(actionKey);
		console.log(content)
		this.notificationService.show({
			content,
			mode: 'positive',
			isClosable: true,
			position: 'bottom-left',
		});
	}
}